import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment from 'moment';

@Component({
   selector: 'app-issue-tc',
   templateUrl: './issue-tc.component.html',
   styleUrls: ['./issue-tc.component.css']
})
export class IssueTCComponent implements OnInit {
   BranchDetails: any;
   SearchModel = {
      StudentNo: '',
   }
   Submitted = false;
   constructor(private financeService: FinanceService, private studentService: StudentService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }


   Reset() {
      this.SearchModel.StudentNo= '',     
      this.Submitted = false;
   }

   IssueTCModel = {
      Gender: "",
      AdmissionDateClass: "",
      ClassPromotion: "",
      StudentNo: '',
      AttendanceLastDate: "",
      ClassDesc:'',
      ClassCode:'',
      DOB: "",
      Reason: "",
      GeneralConduct: "",
      CoScholasticActivity: "",
      SpecialActivity: "",
      ClassPromoted: "",
      ClassFailed: "",
      IssueDate: "",
      LastName: "",
      MiddleName: "",
      FirstName: "",
      ExamLastTaken: "",
      FeePaid: "",
      Attendance: "",
      Remarks: "",
      CourseName: "",
      CertificateDate: "",
      StudentID: 0,
      TCNo:0,
      StudentTCID: 0,
   }

   FilterStudentAdmissionModel = {
      StudentNo: '',
      ClassID: 0,
      SectionID: 0,
      ParentID: 0,
      RegistrationNumber: '',
      FirstName: '',
      ToDate: '',
      FromDate: '',
      TCNo: 0,
      Print: ""
   };

   Clear() {
      this.FilterStudentAdmissionModel.StudentNo= '';
      this.FilterStudentAdmissionModel.Print= '';
      this.FilterStudentAdmissionModel.ClassID= 0;
      this.FilterStudentAdmissionModel.SectionID= 0;
      this.FilterStudentAdmissionModel.ParentID= 0;
      this.FilterStudentAdmissionModel.RegistrationNumber= '';
      this.FilterStudentAdmissionModel.FirstName= '';
      this.FilterStudentAdmissionModel.FromDate= '';
      this.FilterStudentAdmissionModel.ToDate= '';
      this.FilterStudentAdmissionModel.TCNo= 0;      
   }
   AcademicSessionList: any;
   GetAcademicSession() {

      this.lookupService.GetLookupsList('AcademicSession', '').subscribe((data) => {
         this.AcademicSessionList = data.LookupItems;

      });
   };
   ClassList: any;
   GetClass() {

      this.lookupService.GetLookupsList('Class', '').subscribe((data) => {
         this.ClassList = data.LookupItems;

      });
   };
   SectionSearchList: any;
   GetSection() {

      this.FilterStudentAdmissionModel.SectionID = 0;
      var ItemBo = {
         'ItemId': this.FilterStudentAdmissionModel.ClassID
      }
      this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data) => {
         this.SectionSearchList = data.LookupItems;

      });
   };
   MsgExist = '';
   Alert = '';

   GetStudentDetailsByTC() {
      this.MsgExist = '';
      this.Alert = '';

      this.spinnerService.show();
      this.studentService.GetStudentDetailsByTC(JSON.stringify(this.SearchModel)).subscribe((response) => {
         this.spinnerService.hide();
         if (response.StudentDetails != null && response.StudentDetails.StudentStatus != 5) {
            this.IssueTCModel = response.StudentDetails;
            this.IssueTCModel.DOB = response.StudentDetails.DOB != null && response.StudentDetails.DOB != '' ? moment(response.StudentDetails.DOB).format("DD-MMM-YYYY") : '';
            this.IssueTCModel.ClassCode = response.StudentDetails.ClassCode != null && response.StudentDetails.ClassCode != '' ? response.StudentDetails.ClassCode: '';
            this.IssueTCModel.ClassDesc = response.StudentDetails.ClassDesc != null && response.StudentDetails.ClassDesc != '' ? response.StudentDetails.ClassDesc: '';
            this.IssueTCModel.AttendanceLastDate = response.StudentDetails.AttendanceLastDate != null && response.StudentDetails.AttendanceLastDate != '' ? moment(response.StudentDetails.AttendanceLastDate).format("DD-MMM-YYYY") : '';
            this.IssueTCModel.CertificateDate = response.StudentDetails.CertificateDate != null && response.StudentDetails.CertificateDate != '' ? moment(response.StudentDetails.CertificateDate).format("DD-MMM-YYYY") : '';
            this.IssueTCModel.IssueDate = response.StudentDetails.IssueDate != null && response.StudentDetails.IssueDate != '' ? moment(response.StudentDetails.IssueDate).format("DD-MMM-YYYY") : '';

         }
         else {
            this.MsgExist = 'Student does not exist';
         }


      })

   }
   ClearTC() {
      this.Alert = '';
      this.Submitted = false;
      this.IssueTCModel.Gender= "",
      this.IssueTCModel.AdmissionDateClass= "",
      this.IssueTCModel.ClassPromotion= "",
      this.IssueTCModel.StudentNo= "",
      this.IssueTCModel.AttendanceLastDate= "",
      this.IssueTCModel.ClassDesc= "",
      this.IssueTCModel.ClassCode= "",
      this.IssueTCModel.DOB= "",
      this.IssueTCModel.Reason= "",
      this.IssueTCModel.GeneralConduct= "",
      this.IssueTCModel.CoScholasticActivity= "",
      this.IssueTCModel.SpecialActivity= "",
      this.IssueTCModel.ClassPromoted= "",
      this.IssueTCModel.ClassFailed= "",
      this.IssueTCModel.Reason= "",
      this.IssueTCModel.FirstName= "",
      this.IssueTCModel.MiddleName= "",
      this.IssueTCModel.LastName= "",
      this.IssueTCModel.ExamLastTaken= "",
      this.IssueTCModel.FeePaid= "",
      this.IssueTCModel.Attendance= "",
      this.IssueTCModel.Remarks= "",
      this.IssueTCModel.CourseName= "",
      this.IssueTCModel.CertificateDate= "",
      this.IssueTCModel.StudentID= 0,
      this.IssueTCModel.TCNo= 0,
      this.IssueTCModel.StudentTCID= 0,      
      this.MsgExist = '';
   }

   loadingTC = false;

   SaveTCData(valid) {
      this.Submitted = true;
      if (valid) {
         if (this.IssueTCModel.StudentID > 0) {
            this.Submitted = false;
            this.loadingTC = true;
            this.IssueTCModel.DOB = this.IssueTCModel.DOB != null && this.IssueTCModel.DOB != "" ? moment(this.IssueTCModel.DOB).format('DD-MMM-YYYY') : "";
            this.IssueTCModel.AttendanceLastDate = this.IssueTCModel.AttendanceLastDate != null && this.IssueTCModel.AttendanceLastDate != "" ? moment(this.IssueTCModel.AttendanceLastDate).format('DD-MMM-YYYY') : "";
            this.IssueTCModel.CertificateDate = this.IssueTCModel.CertificateDate != null && this.IssueTCModel.CertificateDate != "" ? moment(this.IssueTCModel.CertificateDate).format('DD-MMM-YYYY') : "";
            this.IssueTCModel.IssueDate = this.IssueTCModel.IssueDate != null && this.IssueTCModel.IssueDate != "" ? moment(this.IssueTCModel.IssueDate).format('DD-MMM-YYYY') : "";

            this.studentService.SaveTCData(JSON.stringify(this.IssueTCModel)).subscribe((response) => {
               this.loadingTC = false;
               this.Alert = '';
               this.IssueTCModel.TCNo = response.TCNo;
               this.IssueTCModel.StudentTCID = response.StudentTCID;
               this.globalHelper.CheckActionStatus(response);
               this.GetAllIssueTC();
            })
         }
         else {
            this.Alert = 'Please Search first';
         }
      }
   }
   PrintList() {
      var url = "issuetclistprint?ReportType=PrintStudentList&ClassID=" + this.FilterStudentAdmissionModel.ClassID + "&SectionID=" + this.FilterStudentAdmissionModel.SectionID +"&ParentID=" + this.FilterStudentAdmissionModel.ParentID + "&StudentNo=" + this.FilterStudentAdmissionModel.StudentNo + "&RegistrationNumber=" + this.FilterStudentAdmissionModel.RegistrationNumber + "&FirstName=" + this.FilterStudentAdmissionModel.FirstName + "&FirstName=" + this.FilterStudentAdmissionModel.FirstName + "&ToDate=" + this.FilterStudentAdmissionModel.ToDate + "&FromDate=" + this.FilterStudentAdmissionModel.FromDate
         + "&TCNo=" + this.FilterStudentAdmissionModel.TCNo;
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

   };

   loadingSearch = true;
   IssueTCList: any;
   GetAllIssueTC() {
      this.spinnerService.show();
      this.loadingSearch = true;

      this.FilterStudentAdmissionModel.Print = '';
      this.FilterStudentAdmissionModel.FromDate = this.FilterStudentAdmissionModel.FromDate != null && this.FilterStudentAdmissionModel.FromDate != "" ? moment(this.FilterStudentAdmissionModel.FromDate).format('DD-MMM-YYYY') : "";
      this.FilterStudentAdmissionModel.ToDate = this.FilterStudentAdmissionModel.ToDate != null && this.FilterStudentAdmissionModel.ToDate != "" ? moment(this.FilterStudentAdmissionModel.ToDate).format('DD-MMM-YYYY') : "";

      this.studentService.GetAllIssueTC(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe((response) => {
         this.IssueTCList = response.IssueTCList;
         this.spinnerService.hide();
         this.loadingSearch = false;

      })
   }
   XLSDownload = false;
   FilePath: any;
   GetAllIssueTCXLS() {
      this.XLSDownload = true;
      this.FilterStudentAdmissionModel.FromDate = this.FilterStudentAdmissionModel.FromDate != null && this.FilterStudentAdmissionModel.FromDate != "" ? moment(this.FilterStudentAdmissionModel.FromDate).format('DD-MMM-YYYY') : "";
      this.FilterStudentAdmissionModel.ToDate = this.FilterStudentAdmissionModel.ToDate != null && this.FilterStudentAdmissionModel.ToDate != "" ? moment(this.FilterStudentAdmissionModel.ToDate).format('DD-MMM-YYYY') : "";

      this.FilterStudentAdmissionModel.Print = 'XLS';
      this.studentService.GetAllIssueTC(JSON.stringify(this.FilterStudentAdmissionModel)).subscribe((response) => {
         this.IssueTCList = response.IssueTCList;

         this.FilePath = response.FilePath;
         window.location = response.FilePath;
         this.XLSDownload = false;
         this.globalHelper.CheckActionStatus(response);
      })
   }

   Edit(item){
      this.SearchModel.StudentNo=item.StudentNo;
      this.IssueTCModel.DOB = item.DOB != null && item.DOB != "" ? moment(item.DOB).format('DD-MMM-YYYY') : "";
      this.IssueTCModel.FirstName=item.FirstName;
      this.IssueTCModel.MiddleName=item.MiddleName;
      this.IssueTCModel.LastName=item.LastName;
      this.IssueTCModel.Gender=item.Gender;
      this.IssueTCModel.StudentTCID=item.StudentTCID;
      this.IssueTCModel.StudentID=item.StudentID;
      this.IssueTCModel.TCNo=item.TCNo;
      this.IssueTCModel.ExamLastTaken=item.ExamLastTaken;
      this.IssueTCModel.AdmissionDateClass=item.AdmissionDateClass;    
      this.IssueTCModel.ClassPromotion=item.ClassPromotion;
      this.IssueTCModel.FeePaid=item.FeePaid;
      this.IssueTCModel.Attendance=item.Attendance;
      this.IssueTCModel.ClassPromoted=item.ClassPromoted;
      this.IssueTCModel.ClassDesc=item.ClassDesc;
      this.IssueTCModel.ClassCode=item.ClassCode;
      this.IssueTCModel.CourseName=item.CourseName;
      this.IssueTCModel.SpecialActivity=item.SpecialActivity;
      this.IssueTCModel.CoScholasticActivity=item.CoScholasticActivity;
      this.IssueTCModel.GeneralConduct=item.GeneralConduct;
      this.IssueTCModel.AttendanceLastDate=item.AttendanceLastDate!=null && item.AttendanceLastDate!=''?moment(item.AttendanceLastDate).format("DD-MMM-YYYY") : '';
      this.IssueTCModel.CertificateDate=item.CertificateDate!=null && item.CertificateDate!=''?moment(item.CertificateDate).format("DD-MMM-YYYY") : '';
      this.IssueTCModel.IssueDate=item.IssueDate!=null && item.IssueDate!=''?moment(item.IssueDate).format("DD-MMM-YYYY") : '';
      this.IssueTCModel.Reason=item.Reason;
      this.IssueTCModel.Remarks=item.Remarks;
      this.IssueTCModel.ClassFailed=item.ClassFailed;
   }
   Print(item, PrintType) {
      var Template = this.globalHelper.GetLoginToken().TCTemplate;
      var url = Template + "?ReportType=PrintTC&StudentTCID=" + item.StudentTCID + "&PrintType=" + PrintType;
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
   };


   ngOnInit() {
      this.GetClass();
      this.GetAllIssueTC();
      this.GetAcademicSession();
      this.GetSection();
   }

}
